module.exports = __webpack_public_path__ + "media/images/icons/arrow_right-63fb339bce5cfd6f28f1c8b7f1546b5f.svg";